module.exports = "<div class=\"container\">\r\n  <div class=\"card text-center\">\r\n    <h2 class=\"m-4\">Reingreso Cajas</h2>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <input type=\"file\" accept=\".csv\" (change)=\"csv2Array($event)\">\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/reingresocajas/reingresocajas.component.html
// module id = ../../../../../src/app/components/reingresocajas/reingresocajas.component.html
// module chunks = main